import { render, staticRenderFns } from "./faceComponents.vue?vue&type=template&id=b0325ee6&scoped=true&lang=pug&"
import script from "./faceComponents.vue?vue&type=script&lang=js&"
export * from "./faceComponents.vue?vue&type=script&lang=js&"
import style0 from "./faceComponents.vue?vue&type=style&index=0&id=b0325ee6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0325ee6",
  null
  
)

export default component.exports